import { VendorField } from "./vendor-field.model";
import { VendorType } from "./vendor-type.model";
import { Vendor } from "./vendor.model";


export enum EntryType {
  TMS = 'tms',
  MANUAL = 'manual',
  EXTERNAL = 'external',
  HOTELBEDS_HOTELS = 'HotelBeds - Hotels',
  HOTELBEDS_TRANSFERS = 'HotelBeds - Transfers',
  HOTELBEDS_ACTIVITIES = 'HotelBeds - Activities',
  TOTALSTAY = 'TotalStay',
  STC = 'STC',
}
export interface BookingDetail {
  id: string;
  days: number;
  qty: number;
  vat: number;
  pax: number;
  priceRack: number;
  priceNet: number;
  factor: number;
  priceRate: number;
  priceComments: string;
  internalComments: string;
  serviceName: string;
  location: VendorField;
  taxRate: string;
  weight: number;
  xmlReference: null;
  fromDate: string;
  fromDateTime: string;
  toDate: string;
  toDateTime: string;
  entryType: string;
  status: string;
  createdAt: Date;
  updatedAt: Date;
  deletedAt: null;
  cancelled: boolean;
  fullCancellation: boolean;
  vendorType: VendorType;
  vendor: Vendor;
  serviceSize: VendorField;
  serviceType: VendorField;
  okToPay: boolean;
  reservationConfirmed: boolean;
  comments: string;
  paymentDueDate: string;
  amountPaid: number;
  paymentReference: string;
  confirmation: string;
  voucher: string;
  datePaid: Date;
  additionalPaymentInfo: string;
}
